<template>
  <div
    v-if="$route.name === 'Techcenter' || $route.name === 'TechcenterIframe'"
    class="animated fadeIn">
    <loading
      v-if="loading"
      message="Загружаем информацию о техцентре..."/>
    <div
      v-else
      class="card">
      <div class="row">
        <div class="col-12">
          <div class="card-header">
            <div class="row">
              <h4 class="col-8">{{ techcenter.name }}</h4>
              <div
                v-if="currentUser.isAdmin"
                class="col-4 text-right">
                <a v-if="$route.meta.isIframe"
                   :href="'/techcenters/edit/' + techcenter.id"
                   class="btn btn-primary btn-sm">
                  <i class="fa fa-edit"/> Изменить
                </a>
                <router-link
                  v-else
                  :to="{ name: 'TechcenterEdit', params: { id: techcenter.id }}"
                  class="btn btn-primary btn-sm">
                  <i class="fa fa-edit"/> Изменить
                </router-link>
                <div class="float-right px-2 pt-q"
                     v-if="loadingBlock">
                  <loading
                    :message="false"
                    :size="2"/>
                </div>
                <button
                  v-else-if="techcenter.enabled"
                  class="btn btn-danger btn-sm"
                  @click.prevent="block(!techcenter.enabled)">
                  <i class="fa fa-lock"/> Заблокировать
                </button>
                <button
                  v-else
                  class="btn btn-success btn-sm"
                  @click.prevent="block(!techcenter.enabled)">
                  <i class="fa fa-unlock"/> Разблокировать
                </button>
              </div>
            </div>
            <div class="row">
              <span class="col-1">{{ techcenter.company.name }}</span>
              <span class="col-10">
                <i class="fa fa-map-marker"/> Адрес техцентра: {{ techcenter.city.name }}, {{ techcenter.address }}
              </span>
              <div class="col-1 text-right">
                <span
                  v-if="techcenter.enabled"
                  class="badge badge-success">Активен</span>
                <span
                  v-else
                  class="badge badge-danger">Заблокирован</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-5 pr-0">
          <div class="card-block text-left">
            <h4 class="mb-1"><i class="fa fa-phone"/> Номер телефона:
              <span v-if="techcenter.phone">{{ techcenter.phone | phoneRuFormatting }}</span>
              <span
                v-else
                class="text-danger">не указан!</span>
            </h4>
            <p class="card-text mb-1 text-muted">
              <i class="fa fa-clock-o"/>
              График работы: {{ techcenter.schedule }}
            </p>

            <p class="card-text mb-0 text-muted"><i class="fa fa-user"/> Менеджеры:</p>
            <div class="mb-1">
              <span
                v-for="user in techcenter.users"
                class="badge badge-info">
                <span v-if="$route.meta.isIframe">
                   {{ user.fullname }}
                </span>
                <router-link v-else :to="{ name: 'ViewProfile', params: { id: user.id }}">
                  {{ user.fullname }}
                </router-link>
              </span>
            </div>
            <div>
              <ap-gallery :images="techcenter.images"/>
            </div>
            <h5><i class="fa fa-compass"/> Описание проезда</h5>
            <a
              :href="techcenter.link"
              class="card-text"
              target="_blank">Схема проезда</a>
            <div v-html="compiledMarkdown"/>
          </div>
        </div>
        <div class="col-7 pt-1">
          <loading
            v-if="loadingMap"
            message="Загрузка карты"/>
          <div
            v-else
            class="card-block col-12">
            <yandex-map
              :coords="getCoords(techcenter.coords)"
              :cluster-options="{
                1: {clusterDisableClickZoom: true}
              }"
              zoom="15"
              style="width: 100%; height: 400px;"
              map-type="map"
              @map-was-initialized=""
            >
              <ymap-marker
                :marker-id="techcenter.id"
                :coords="getCoords(techcenter.coords)"
                marker-type="placemark"
                cluster-name="1"
              />
            </yandex-map>
          </div>
        </div>
      </div>
    </div>
    <TcOrdersList v-if="!loading" :techcenter-id="$route.params.id"></TcOrdersList>
  </div>
  <router-view v-else/>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import marked from 'marked'
  import ApGallery from '../../components/ApParts/ApGallery'
  import TcOrdersList from './components/TcOrdersList'

  export default {
    computed: {
      compiledMarkdown: function () {
        if (this.techcenter.description) {
          return marked(this.techcenter.description, { sanitize: true })
        }
        return '<div class="alert alert-danger">Описание не заполнено</div>'
      },
      ...mapState({
        techcenter: state => state.techcenterStore.techcenter,
        currentUser: state => state.globalStore.user
      })
    },
    watch: {
      '$route': 'loadTechcenterData'
    },
    components: {
      TcOrdersList,
      ApGallery
    },
    data () {
      return {
        loading: false,
        loadingBlock: false,
        loadingMap: false,
        editDescription: false,
        description: '',
        id: null
      }
    },
    methods: {
      loadTechcenterData () {
        this.loading = true
        this.id = this.$route.params.id
        this.$store.dispatch('getTechcenterById', {id: this.id, imgWidth: 60, imgHeight: 50})
          .then(() => {
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
      block (enabled) {
        this.loadingBlock = true
        this.$store.dispatch('blockTechcenter', {id: this.id, enabled: enabled})
          .then(() => {
            this.loadingBlock = false
            this.addToast({
              text: 'Настройки успешно сохранены',
              type: 'success',
              dismissAfter: 3000
            })
          })
          .catch((error) => {
            this.loadingBlock = false
            this.addToast({
              text: 'Ошибка при сохранении данных: ' + error,
              type: 'danger',
              dismissAfter: 3000
            })
          })
      },
      getCoords (coords) {
        return coords.split(', ')
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      this.loadTechcenterData()
    }
  }
</script>



// WEBPACK FOOTER //
// View.vue?4df9b4ff